module.exports = __webpack_public_path__ + "img/s3-4-ja.3e665d7e.jpg";